export default V => [
  {
    name: 'filiations',
    path: '/filiations',
    redirect: '/filiations/requests',
    component: V('filiations/Base'),
    children: [
      {
        name: 'filiations.list',
        path: '',
        component: V('filiations/List'),
        meta: {
          title: 'Afiliados',
          breadcrumb: [{ title: 'Afiliados' }],
        },
        children: [
          {
            name: 'filiations.list.setAuthor',
            path: ':id/set-author',
            component: V('filiations/SetAuthor'),
            meta: {
              title: 'Vincular autor',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Vincular autor' },
              ],
            },
          },
          {
            name: 'filiations.list.editPercentages',
            path: ':id/edit-percentages',
            component: V('filiations/EditPercentages'),
            meta: {
              title: 'Editar percentuais',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Editar percentuais' },
              ],
            },
          },
          {
            name: 'filiations.list.filter',
            path: 'filter',
            component: V('filiations/Filter'),
            meta: {
              title: 'Filtrar afiliados',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Filtrar' },
              ],
            },
          },
        ],
      },
      {
        path: 'balances',
        component: V('filiations/balances/Base'),
        children: [
          {
            name: 'filiations.balances.list',
            path: '',
            component: V('filiations/balances/List'),
            meta: {
              title: 'Balanços',
              breadcrumb: [{ title: 'Balanços' }],
            },
            children: [
              {
                name: 'filiations.balances.list.closeMonth',
                path: 'close-month',
                component: V('filiations/balances/CloseMonth'),
                meta: {
                  title: 'Balanços',
                  breadcrumb: [{ title: 'Balanços' }],
                },
              },
            ],
          },
        ],
      },
      {
        name: 'filiations.show',
        path: ':id',
        component: V('filiations/Show'),
        meta: {
          title: 'Afiliado',
          breadcrumb: [
            { title: 'Afiliados', name: 'filiations.list' },
            { title: 'Afiliado' },
          ],
        },
      },
      {
        path: ':id/balance',
        component: V('filiations/balance/Component'),
        children: [
          {
            name: 'filiations.balance.purchases',
            path: '',
            component: V('filiations/balance/Purchases'),
            meta: {
              title: 'Afiliado',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Afiliado', name: 'filiations.show' },
                { title: 'Balanço' },
              ],
            },
          },
          {
            name: 'filiations.balance.subscriptions',
            path: 'subscriptions',
            component: V('filiations/balance/Subscriptions'),
            meta: {
              title: 'Afiliado',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Afiliado', name: 'filiations.show' },
                { title: 'Balanço' },
              ],
            },
          },
          {
            name: 'filiations.balance.videoWatches',
            path: 'video-watches',
            component: V('filiations/balance/VideoWatches'),
            meta: {
              title: 'Afiliado',
              breadcrumb: [
                { title: 'Afiliados', name: 'filiations.list' },
                { title: 'Afiliado', name: 'filiations.show' },
                { title: 'Balanço' },
              ],
            },
          },
        ],
      },
      {
        path: 'requests',
        component: V('filiations/requests/Base'),
        children: [
          {
            name: 'filiations.requests.list',
            path: 'requests',
            component: V('filiations/requests/List'),
            meta: {
              title: 'Solicitações',
              breadcrumb: [{ title: 'Solicitações' }],
            },
          },
          {
            name: 'filiations.requests.review',
            path: 'requests/:id',
            component: V('filiations/requests/Review'),
            meta: {
              title: 'Revisar',
              breadcrumb: [
                { title: 'Solicitações', name: 'filiations.requests.list' },
                { title: 'Revisar' },
              ],
            },
            children: [
              {
                name: 'filiations.requests.review.reject',
                path: 'reject',
                component: V('filiations/requests/Reject'),
                meta: {
                  title: 'Rejeitar filiação',
                  breadcrumb: [
                    { title: 'Solicitações', name: 'filiations.requests.list' },
                    { title: 'Revisar', name: 'filiations.requests.review' },
                    { title: 'Rejeitar' },
                  ],
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
